<template>
    <el-dialog
        title="公司"
        :visible.sync="isVisible"
        :close-on-click-modal="false"
    >
        <el-form
            :model="form"
            label-position="top"
            ref="form"
        >
            <el-form-item label="logo">
                <ox-uploader
                    :drag="false"
                    accept=".jpg,.png,.jpeg"
                    list-type="picture-card"
                    category-id="5ec8993a39f1b019fcb76892"
                    :file-list="form.logo?[form.logo]:[]"
                    @success="onLogoUploaded"
                    @remove="onLogoRemoved"
                />
            </el-form-item>
            <el-row :gutter="15">
                <el-col :span="16">
                    <el-form-item label="标题">
                        <el-input
                            v-model="form.name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="状态">
                        <el-checkbox v-model="form.is_visible">公开可见</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="优先级">
                        <el-checkbox v-model="form.top">置顶</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="8">
                    <el-form-item label="联系人">
                        <el-input
                            v-model="form.contact"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系电话">
                        <el-input
                            v-model="form.phone"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="联系邮箱">
                        <el-input
                            v-model="form.email"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="一句话简介">
                <el-input
                    v-model="form.brief"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="详细介绍">
                <ox-editor
                    category-id="5ec8993a39f1b019fcb76892"
                    v-model="form.description"
                />
            </el-form-item>
        </el-form>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                @click="hide"
                round
            >取 消</el-button>
            <el-button
                type="primary"
                @click="save"
                round
                :loading="isProcessing"
            >确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OxUploader from "../../ox/components/form/OxUploader";
import OxEditor from "../../ox/components/form/OxEditor";

export default {
    name: "DemandFormDialog",
    components: {
        OxUploader,
        OxEditor
    },
    data: function() {
        return {
            isProcessing: false,
            isVisible: false,
            form: {
                id: null,
                logo: null,
                name: null,
                contact: null,
                phone: null,
                email: null,
                brief: null,
                description: null,
                is_visible: true,
                top: false
            }
        };
    },
    methods: {
        reset() {
            this.form = {
                id: null,
                logo: null,
                name: null,
                contact: null,
                phone: null,
                email: null,
                brief: null,
                description: null,
                is_visible: true,
                top: false
            };
        },
        show(data = null) {
            if (data) {
                this.form = {
                    id: data.id,
                    logo: data.logo,
                    name: data.name,
                    contact: data.contact,
                    phone: data.phone,
                    email: data.email,
                    brief: data.brief,
                    description: data.description,
                    is_visible: data.is_visible,
                    top: data.top
                };
                if (this.form.logo) {
                    this.form.logo.url = this.form.logo.path;
                }
            } else {
                this.reset();
            }
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        },
        onLogoUploaded(resp, file) {
            this.form.logo = file;
        },
        onLogoRemoved() {
            this.form.logo = null;
        },
        save() {
            this.isProcessing = true;
            this.$ox
                .service("company")
                .save(this.form)
                .then(res => {
                    this.$notify.success({
                        title: "操作成功",
                        message: `公司“${this.form.name}”已保存`
                    });
                    this.hide();
                    this.$refs.form.resetFields();
                    this.$refs.form.clearValidate();
                    this.$emit("success", res);
                })
                .catch(err => {
                    this.$emit("error", err);
                    this.$notify.error({
                        title: "操作失败",
                        message: "公司信息保存失败，请与系统维护人员联系"
                    });
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        }
    }
};
</script>

<style scoped>
</style>